export const BOARD_COLUMN_SET = 'BOARD_COLUMN_SET';
export const BOARD_THEME_SET = 'BOARD_THEME_SET';
export const BOARD_COLUMN_INIT = 'BOARD_COLUMN_INIT';

export const boardColumnInit = () => {
  return {
    type: BOARD_COLUMN_INIT,
  };
};

export const boardColumnSet = (data) => {
  return {
    type: BOARD_COLUMN_SET,
    data,
  };
};

export const boardThemeSet = (data) => {
  return {
    type: BOARD_THEME_SET,
    data,
  };
};

const initialState = {
  board: {
    column: ['logIdx', 'areaNo', 'areaNm', 'modelNo', 'o2', 'h2s', 'co', 'hc', 'co2', 'status', 'battery', 'rgstDt'],
    theme: 'excel',
  },
};

export const mainSetting = (state = initialState, action) => {
  switch (action.type) {
    case 'BOARD_COLUMN_INIT':
      return initialState;
    case 'BOARD_COLUMN_SET':
      return {
        board: {
          ...state.board,
          column: action.data,
        },
      };
    case 'BOARD_THEME_SET':
      return {
        board: {
          ...state.board,
          theme: action.data,
        },
      };
    default:
      return state;
  }
};
